import loadable from '@loadable/component'

export default loadable(() =>
  import(
    /* webpackChunkName: "ProductRedirect" */ 'pages/ProductRedirect/ProductRedirect'
  )
)
